/* eslint-disable */
import 'intersection-observer';

if (typeof window !== 'undefined') {
    (window as any).Sentry = (window as any).Sentry || undefined;
}
